import { render, staticRenderFns } from "./Recommendation.vue?vue&type=template&id=665d2d79&scoped=true&"
import script from "./Recommendation.vue?vue&type=script&lang=js&"
export * from "./Recommendation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665d2d79",
  null
  
)

export default component.exports